module.exports = __webpack_public_path__ + "static/profil-145_optimized-98b797f635c1c15d5ff28e0b8ec70051.jpg";